import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';


import { BackendService } from '../../backend.service';
import { slide } from '../../animations';


@Component({
  selector: 'invite-member-modal',
  templateUrl: './invite-member-modal.component.html',
  styleUrls: ['./invite-member-modal.component.scss'],
  animations: [slide]
})
export class InviteMemberModalComponent implements OnInit {

  @Input()  selectedCompany: any;
  @Input()  userType: any;
  @Input()  companyType: any;
  @Output() onHideInviteModal = new EventEmitter<boolean>();

  processingInvite = false;
  inviteError = null;

  member = {
    firstName: "",
    lastName: "",
    email: "",
    password: Math.random().toString(36).slice(-8).replace(/[l1]/gi,'i'),
    companyKey: "",
    userLevel: 1,
    designation: ""
  }


  constructor(
    private backendService: BackendService
  ) { }

  ngOnInit() {
  }

  onHideModal() {
    this.onHideInviteModal.emit(true);
  }

  submitForm() {
    this.member.companyKey = this.selectedCompany.$key;
    this.member.designation = this.userType;

    if (this.companyType == 'vendor') {
      this.member.userLevel = 0;
    } else {
      if (this.userType == 'companyOwner') {
        this.member.userLevel = 2;
      } else if (this.userType == 'companyManager') {
        this.member.userLevel = 3;
      } else {
        this.member.userLevel = 1;
      }
    }

    this.processingInvite = true;
    this.backendService.inviteUser(this.member)
                       .subscribe( data => {
                          this.processingInvite = false;
                          if (data.error) {
                            this.inviteError = data.msg;
                          } else {
                            this.inviteError = null;
                            this.onHideModal();
                          }
                       });
  }


}



// WEBPACK FOOTER //
// ./src/app/members/invite-member-modal/invite-member-modal.component.ts